<template>
  <navbar></navbar>
  <router-view/>
  <DemoManager v-if="showDemoManager" :key="demoManagerKey"></DemoManager>
  <Footer></Footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'
import DemoManager from './components/DemoManager.vue'

export default defineComponent({
  name: 'App',
  components: {
    Navbar,
    Footer,
    DemoManager
  },
  data () {
    return {
      showDemoManager: false,
      demoManagerKey: 0
    }
  },
  mounted () {
    window.addEventListener('load-demo-manager', () => {
      this.showDemoManager = true
      this.demoManagerKey += 1
    })
    window.addEventListener('deactivate-demo-manager', () => {
      this.showDemoManager = false
    })

    // ✅ INICIAR MONITORING INTELIGENTE
    this.startSmartMonitoring()
  },
  methods: {
    startSmartMonitoring () {
      let isMonitoring = false;

      const checkOnce = async () => {
        try {
          const [maintenanceRes, pagesRes] = await Promise.all([
            fetch('/api/check-maintenance?_=' + Date.now()),
            fetch('/api/blocked-pages?_=' + Date.now())
          ]);

          const maintenanceData = await maintenanceRes.json();
          const pagesData = await pagesRes.json();

          const currentPath = window.location.pathname;

          if (maintenanceData.maintenance_mode &&
              !currentPath.includes('/maintenance') &&
              !currentPath.includes('/adminl2')) {
            window.location.href = '/maintenance';
            return;
          }

          if (pagesData.blocked_pages &&
              pagesData.blocked_pages.includes(currentPath) &&
              !currentPath.includes('/page-disabled') &&
              !currentPath.includes('/adminl2')) {
            window.location.href = '/page-disabled';
          }
        } catch (error) {
          console.log('Monitor: Error de conexión (no crítico)');
        }
      };

      const initMonitoring = () => {
        if (isMonitoring) return;
        isMonitoring = true;

        // ✅ SOLO verificar en momentos clave:

        // 1. Cuando la página se hace visible
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) checkOnce();
        });

        // 2. ✅ ELIMINADO el history.pushState - Usamos Router Events en su lugar
        // (más limpio y sin warnings)

        // 3. Una vez cada 15 minutos
        setInterval(checkOnce, 15 * 60 * 1000);

        // 4. Verificación inicial
        setTimeout(checkOnce, 2000);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMonitoring);
      } else {
        initMonitoring();
      }
    }
  }
})
</script>

<style>

</style>
